import { useInfiniteQuery } from 'react-query';
import { PageSection, QUERY_KEYS, Profile } from '@24i/nxg-sdk-photon/src';
import { useTranslation } from 'react-i18next';
import { useContentData } from '@24i/nxg-sdk-smartott-shared/src/context/ContentData';
import { log } from '@24i/nxg-core-utils/src/logger';
import { useFirebase } from '../../../context/Firebase';

const INITIAL_STALE_TIME = 10 * 10000;

export const getPlaylistQueryKey = (
    sectionsStructure: PageSection[],
    pageId?: string,
    selectedProfile?: Profile | null,
    language?: string
) => [QUERY_KEYS.playlists, pageId, sectionsStructure?.[0]?.id, selectedProfile?.id, language];

const usePlaylistsQuery = (
    sectionsStructure: PageSection[],
    pageId?: string,
    size?: number,
    selectedProfile?: Profile | null,
    hasScreenType?: boolean
) => {
    const { fetchPlaylist } = useContentData();
    const { i18n } = useTranslation();
    const { language } = i18n;
    const fetchSize = size || sectionsStructure.length;
    const { recordError } = useFirebase();

    return useInfiniteQuery<PageSection[]>(
        getPlaylistQueryKey(sectionsStructure, pageId, selectedProfile, language),
        ({ pageParam }) => fetchPlaylist(sectionsStructure, fetchSize, pageParam || 0),
        {
            getNextPageParam: (_lastPage, pages) => {
                if (pages.length < sectionsStructure.length / fetchSize) {
                    return pages.length;
                }
                return undefined;
            },
            enabled: !!sectionsStructure.length,
            onError: (error) => {
                log(error);
                recordError?.(error);
            },
            staleTime: !hasScreenType ? 0 : INITIAL_STALE_TIME,
        }
    );
};

export default usePlaylistsQuery;
